import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Line from './line';
import { ErrorType } from '../../common/error-type';
import { StringsMapping } from '../../common/strings';

function StatusOverview(props) {
  const {
    newI18n,
    data,
    noConversionGoalsWithRevenue,
    TrackingTypeFilterStore,
    router,
    instrumentationLog,
  } = props;

  const title = useMemo(
    () =>
      newI18n.getString(StringsMapping.Status_Title),
    [newI18n]
  );
  const subtitle = useMemo(
    () =>
      newI18n.getString(StringsMapping.Status_Subtitle)
    , [newI18n]
  );
  const alertText = useMemo(
    () =>
      newI18n.getString(StringsMapping.Status_Alert)
    , [newI18n]
  );

  const alertNum = useMemo(
    () => _.reduce(data, (memo, status) => memo + status.GoalCount, 0),
    [data]
  );

  return (
    <div className="conversion-trackig-tile-error-status">
      <div className="alert-group">
        <div className="alert-text">{alertText}</div>
        <div className="alert-number">{alertNum}</div>
      </div>
      <div className="details-group">
        <div className="title-group">
          <div className="status-overview-title" >{title}</div>
          <div className="status-overview-subtitle">{subtitle}</div>
        </div>
        <div className="errors-group">
          {_.map(data, (status, index) => (
            <React.Fragment key={`${status.GoalTrackingStatus}-${index}`}>
              <Line
                number={status.GoalCount}
                type={status.GoalTrackingStatus}
                newI18n={newI18n}
                goalNames={status.GoalNames}
                TrackingTypeFilterStore={TrackingTypeFilterStore}
                router={router}
                instrumentationLog={instrumentationLog}
              />
            </React.Fragment>
          ))
          }
          {noConversionGoalsWithRevenue && (
            <Line
              number={0}
              type={ErrorType.RecordingConversions}
              newI18n={newI18n}
            />
          )}
        </div>
      </div>

    </div>
  );
}
StatusOverview.defaultProps = {
  data: [],
  noConversionGoalsWithRevenue: false,
  TrackingTypeFilterStore: _.noop,
  router: { navigateToRoute: _.noop },
  instrumentationLog: { SeeAllClicked: _.noop },
};

StatusOverview.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    GoalCount: PropTypes.number.isRequired,
    GoalNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    GoalTrackingStatus: PropTypes.string.isRequired,
  })),
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  noConversionGoalsWithRevenue: PropTypes.bool,
  TrackingTypeFilterStore: PropTypes.func,
  router: PropTypes.shape({
    navigateToRoute: PropTypes.func.isRequired,
  }),
  instrumentationLog: PropTypes.shape({
    SeeAllClicked: PropTypes.func.isRequired,
  }),
};

export default StatusOverview;
